/**
 * Local Storage Service
 * Wrapper for localStorage with fallback
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('storageSvc', storageSvc);

    storageSvc.$inject = ['$window'];

    function storageSvc($window) {
        var storage = $window.localStorage;
        var isAvailable = testStorage();

        var service = {
            get: get,
            set: set,
            remove: remove,
            clear: clear,
            isAvailable: isAvailable
        };

        return service;

        // ====================================================================

        function get(key, defaultValue) {
            if (!isAvailable) {
                return defaultValue;
            }

            try {
                var value = storage.getItem(key);
                if (value === null) {
                    return defaultValue;
                }

                // Try to parse JSON
                try {
                    return JSON.parse(value);
                } catch (e) {
                    return value;
                }
            } catch (e) {
                console.warn('[Storage] Failed to get item:', key, e);
                return defaultValue;
            }
        }

        function set(key, value) {
            if (!isAvailable) {
                return false;
            }

            try {
                var serialized = typeof value === 'string' ? value : JSON.stringify(value);
                storage.setItem(key, serialized);
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to set item:', key, e);
                return false;
            }
        }

        function remove(key) {
            if (!isAvailable) {
                return false;
            }

            try {
                storage.removeItem(key);
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to remove item:', key, e);
                return false;
            }
        }

        function clear() {
            if (!isAvailable) {
                return false;
            }

            try {
                storage.clear();
                return true;
            } catch (e) {
                console.warn('[Storage] Failed to clear storage:', e);
                return false;
            }
        }

        function testStorage() {
            try {
                var test = '__storage_test__';
                storage.setItem(test, test);
                storage.removeItem(test);
                return true;
            } catch (e) {
                console.warn('[Storage] localStorage not available:', e);
                return false;
            }
        }
    }
})();

